import type {
  ResultError,
  ResultOk
} from 'types';

export const ok = <T>(value: T): ResultOk<T> => ({
  type: 'ok',
  value
});

export const err = <E extends string>(error: E): ResultError<E> => ({
  type: 'error',
  error
});
